import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    search: {
        height: '32px',
        paddingLeft: '15px',
        paddingRight: '8px',
        fontSize: '16px',
        width: '250px',
        border: 0,
        borderRadius: 15,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        boxShadow: '0 1px 0 0 hsla(0,0%,100%,.15), inset 0 1px 0 0 rgba(0,0,0,.15)',
    },
    btn: {
        display: 'inline-block',
        padding: '5px 12px',
        fontSize: '14px',
        color: '#00a3f9',
        background: 'none',
        border: '1px solid #00a3f9',
        borderRadius: 12,
        marginLeft: 15,
        cursor: 'pointer',
        '&:hover': {
            borderColor: 'rgba(255,255,255,.15)',
            color: '#ffce01'
        },
        outline: 'none'
    }
}));

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'login', label: 'Логин'},
    { id: 'registration', label: 'Дата регистрации'},
    { id: 'balance', label: 'Баланс'},
    { id: 'sum_deposit', label: 'Сумма пополнений'},
    { id: 'sum_withdrawals', label: 'Сумма выводов'},
    { id: 'sum_win', label: 'Сумма выигрышей'},
    { id: 'groups_cashiers', label: 'Закреплен группой'}
  ];

const getRows = (search) => {
    return search.map((item) => {
        return {
            id: item.id,
            login: item.login,
            registration: getDate(+item.registration),
            balance: new Intl.NumberFormat('ru-RU').format(item.balance) + '₽',
            sum_deposit: new Intl.NumberFormat('ru-RU').format(item.sum_deposit) + '₽',
            sum_withdrawals: new Intl.NumberFormat('ru-RU').format(item.sum_withdrawals) + '₽',
            sum_win: new Intl.NumberFormat('ru-RU').format(item.sum_win) + '₽',
            groups_cashiers: item.groups_cashiers ? item.groups_cashiers : ''
        }
    })
} 

export {
    useStyles,
    columns,
    getRows
}